import { UUID } from '@/types';
import service from '@/services/linesheet';
import { IPage } from '@/services/gql/generic-find';
import { promiseError } from '@/store/utils';
import { StateLinesheets, Linesheet } from '../types';

export default ({
  trackMutations,
}: any) => {

  trackMutations({
    REMOVE: (id: UUID) => ({ id }),
  });

  return {
    namespaced: true,
    state: () => ({
      isLoading: false,
      list: [],
      page: {
        number: 1,
        recordCount: 0,
        size: 10,
      },
      USER_LINESHEET_LIMIT: service.USER_LINESHEET_LIMIT,
    } as StateLinesheets),
    getters: {
      linesheetLimitReached: (state: StateLinesheets) => state.page.recordCount >= service.USER_LINESHEET_LIMIT,
    },
    mutations: {
      IS_LOADING(state: StateLinesheets, isLoading: boolean) {
        state.isLoading = isLoading;
      },
      LOAD(state: StateLinesheets, data: any = []) {
        state.list = data;
      },
      REMOVE(state: StateLinesheets, id: UUID) {
        // reduce record count by 1
        state.page.recordCount = state.page.recordCount - 1;

        // remove item from list
        state.list = state.list.filter((item: Linesheet) => (
          item.id !== id
        ));
      },
      UPDATE_PAGE(state: StateLinesheets, payload: any) {
        state.page = {
          ...state.page,
          ...payload,
        };
      },
    },
    actions: {
      load: ({ commit, state }: any, page: IPage) => {
        // update page details if required
        page && commit('UPDATE_PAGE', page);

        // run query off state of page
        const pageIndex = state.page.number - 1;
        const pageSize = state.page.size;
        commit('IS_LOADING', true);
        return service
          .find(`id, archived, title`, {
            limit: pageSize,
            offset: pageSize * pageIndex,
            orderBy: {
              title: 'asc',
            },
          })
          .then(response => {
            commit('LOAD', response.result);
            commit('UPDATE_PAGE', {
              recordCount: response.count,
            });
          })
          .catch(promiseError('LINESHEETS_LOAD', commit))
          .finally(() => commit('IS_LOADING', false));
      },
      remove: ({ commit }: any, id: string) => (
        service
          .remove(id)
          .then(() => commit('REMOVE', id))
          .catch(promiseError('LINESHEETS_REMOVE', commit))
      ),
    },
  };
};
